import { Box } from "@mui/material";

const MainLayout = ({ children, sx = {} }) => {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: "#F0F7FD",
        width: "100%",
        maxWidth: "1580px",
        margin: "0 auto",
        minHeight: "100vh",
        ...sx, // allow page-level overrides
      }}
    >
      {children}
    </Box>
  );
};

export default MainLayout;